import { render } from "./DeadHall.vue?vue&type=template&id=42bac0d6&scoped=true"
import script from "./DeadHall.vue?vue&type=script&lang=js"
export * from "./DeadHall.vue?vue&type=script&lang=js"

import "./DeadHall.vue?vue&type=style&index=0&id=42bac0d6&scoped=true&lang=css"

import exportComponent from "F:\\Users\\Sahar\\Desktop\\Super Tactico - Official App\\Online - Routed\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bac0d6"]])

export default __exports__